<template>
  <div :class="['max-pos-button', node.block ? 'max-pos-button--block' : '']" data-max-host>
    <button
      type="button"
      :class="buttonClass"
      :disabled="node.disabled === true || iface.busy.value"
      :aria-busy="iface.busy.value || undefined"
      :aria-label="node.iconOnly ? node.label : undefined"
      :title="node.iconOnly ? node.label : undefined"
      v-on:click="iface.run(node.on && node.on.click, node.scope || {})"
    >
      <MaxIcon v-if="node.icon" :name="node.icon" />
      <template v-if="!node.iconOnly">{{ node.label }}</template>
    </button>
  </div>
</template>

<script>
import { useMaxInterface } from '#max-runtime/context.ts'

// POS draws Max buttons as its own Bootstrap buttons. MaxIcon draws the tool's own icons and
// the built-in ones with the Font Awesome icons POS uses for the same actions (MaxPosIcon)
const BUTTON_CLASS = {
  neutral: 'btn-default',
  accent: 'btn-primary',
  positive: 'btn-success',
  warning: 'btn-warning',
  negative: 'btn-danger'
}

const SIZE_CLASS = { sm: 'btn-sm', lg: 'btn-lg' }

export default {
  props: ['node'],
  setup () {
    return { iface: useMaxInterface() }
  },
  computed: {
    buttonClass () {
      const variant = this.node.variant || 'solid'
      const classes = ['btn']
      if (variant === 'ghost' || variant === 'link') classes.push('btn-link')
      else if (variant === 'solid') classes.push(BUTTON_CLASS[this.node.intent] || 'btn-default')
      else classes.push('btn-default')
      if (variant === 'ghost') classes.push('max-pos-button--ghost')
      if (SIZE_CLASS[this.node.size]) classes.push(SIZE_CLASS[this.node.size])
      if (this.node.block) classes.push('btn-block')
      return classes
    }
  }
}
</script>

<style scoped>
.max-pos-button--block {
  display: block;
  width: 100%;
}
.max-pos-button--ghost {
  text-decoration: none;
  color: inherit;
}
</style>
